<template>
  <div>
    <van-tabs v-model="active">
      <van-tab title="昨日收入">
        <div class="tab-container">
          <v-income
            :form="ruleForm"
            detail
          />
        </div>
      </van-tab>
      <van-tab title="昨日支出">
        <div class="tab-container">
          <v-expend
            :form="ruleForm"
            detail
          />
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import { Detail } from "@/api/daily";
import vIncome from "./income";
import vExpend from "./expend";
export default {
  name: "Index",
  components: {
    vIncome,
    vExpend
  },
  data() {
    return {
      active: 0,
      shopInfo: {},
      ruleForm: {}
    };
  },
  created() {
    this.active = this.$route.query.type;
    this.shopInfo = JSON.parse(localStorage.getItem("sushiWechatShopInfo"));
    this.getDetail();
  },
  methods: {
    formatTime(date){
      const y = date.getFullYear();
      let m = date.getMonth() + 1,
      d = date.getDate();
      if(m < 10)
      m = '0' + m
      if(d < 10)
      d = '0' + d
      return `${y}-${m}-${d}`
    },
    getDetail() {
      this.$toast.loading({
        duration: 0,
        message: "加载中...",
        forbidClick: true
      });
      const yesterday = this.formatTime(new Date(new Date().setTime(new Date().getTime()-24*60*60*1000)))
      Detail({
        shopId: this.shopInfo.sid,
        retailyTime: yesterday
      })
        .then(res => {
          this.$toast.clear();
          if (res.code == 0){
            if(res.dayDaily){
              this.$set(this, "ruleForm", res.dayDaily);
            }else{
              this.$toast('暂无日报')
              this.$router.go(-1);
            }
          }
        })
        .catch(() => {
          this.$toast.clear();
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.tab-container {
  padding: 20px;
  .van-button {
    margin-top: 30px;
  }
}
</style>